/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeCompletePaymentRequest, serializeInvoiceDto, type CompletePaymentRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/payments/{paymentId}/complete
 */
export interface CompleteRequestBuilder extends BaseRequestBuilder<CompleteRequestBuilder> {
    /**
     * Settles a payment that was recorded as Pending, for instance once the processor confirms it. Only a pending payment can be completed — one already completed, failed or refunded is refused — and its amount must still fit within the invoice's outstanding balance, which may have moved since it was recorded. On success the payment starts counting toward the balance and the invoice becomes PartiallyPaid or Paid. A voided or cancelled invoice is the exception: the payment is still marked completed but the invoice keeps its terminal status.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CompletePaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Settles a payment that was recorded as Pending, for instance once the processor confirms it. Only a pending payment can be completed — one already completed, failed or refunded is refused — and its amount must still fit within the invoice's outstanding balance, which may have moved since it was recorded. On success the payment starts counting toward the balance and the invoice becomes PartiallyPaid or Paid. A voided or cancelled invoice is the exception: the payment is still marked completed but the invoice keeps its terminal status.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CompletePaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CompleteRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/payments/{paymentId}/complete";
/**
 * Metadata for all the requests in the request builder.
 */
export const CompleteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CompleteRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCompletePaymentRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
